/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LinkDisplayType } from '../../models/link-display-type';
import { LinkType } from '../../models/link-type';
import { PaginatedResponse } from '../../models/paginated-response';

export interface LinksControllerFindAll$Params {
  page?: number;
  limit?: number;
  search?: string;
  displayType?: LinkDisplayType;
  linkType?: LinkType;
  isActive?: boolean;
  sortBy?: 'title' | 'sortOrder' | 'createdAt';
  sortOrder?: 'ASC' | 'DESC';
}

export function linksControllerFindAll(http: HttpClient, rootUrl: string, params?: LinksControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedResponse>> {
  const rb = new RequestBuilder(rootUrl, linksControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('displayType', params.displayType, {});
    rb.query('linkType', params.linkType, {});
    rb.query('isActive', params.isActive, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedResponse>;
    })
  );
}

linksControllerFindAll.PATH = '/links';
